import {inDevEnvironment, inTestEnvironment} from '../util/environment'

if (up.version !== '3.12.0') {
  console.error('Please check, whether you can drop this monkey patch!')
}

// NOTE: This is a polyfill for [data-confirm] and [data-method].
// We want this functionality to get handled by Unpoly and not by jQuery UJS.
// Long term, we should replace all places in the code with `up-` attributes and get rid of this.

function convertDataAttr(dataAttr, upAttr) {
  up.macro('[' + dataAttr + ']:is(form, input[type=submit], button[type=submit], button:not([type])', function (confirmable) {
    if (inDevEnvironment() || inTestEnvironment()) {
      console.log(`[${dataAttr}] polyfill used`)
    }

    let form = up.form.get(confirmable)
    if (up.form.isSubmittable(form)) {
      const dataAttrValue = confirmable.getAttribute(dataAttr)

      if (dataAttrValue !== 'false') {
        up.element.setMissingAttr(confirmable, upAttr, dataAttrValue)
      }
      confirmable.removeAttribute(dataAttr)
    }
  })
}

convertDataAttr('data-confirm', 'up-confirm')
convertDataAttr('data-method', 'up-method')
